import React, { useEffect, useState } from "react";
import { motion } from "motion/react";
import { Button, Typography } from "@mui/material";

import art1 from "../../../assets/img/art1.png";
import art2 from "../../../assets/img/art2.png";
import prodepLogo from "../../../assets/img/prodep_logo.png";
import prodepnames from "../../../assets/img/names.jpg";
import { useMediaQuery } from "react-responsive";

const Research = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const clickViewPaperBtnHandler = () => {
    window.open("https://ieeexplore.ieee.org/document/9941896");
  };

  const clickSourceCodeBtnHandler = () => {
    window.open("https://github.com/thushaltk/prodep-client");
  };

  return (
    <div
      style={{
        width: "100%",
        height: "600px",
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
        boxShadow: "10px 3px 25px #E0E0E0",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {isTabletOrMobile ? (
          <div style={{ width: "100%", height: "100%" }}>
            <img src={art1} style={{ width: "100%", height: "60%" }} />
          </div>
        ) : (
          <>
            <div style={{ width: "35%", height: "100%" }}>
              <img src={art1} style={{ width: "100%", height: "60%" }} />
            </div>
            <div style={{ width: "35%", height: "100%" }}>
              <img src={art2} style={{ width: "100%", height: "60%" }} />
            </div>
          </>
        )}
      </div>

      {/* //!seperate div */}
      <div
        style={{
          width: "100%",
          height: "600px",
          position: "absolute",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: isTabletOrMobile ? "100%" : "60%",
            height: "100%",
            display: "flex",
            justifyContent: "start",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "80%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {isTabletOrMobile ? (
              <motion.img
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                src={prodepLogo}
                style={{ width: "300px", height: "50%" }}
              />
            ) : (
              <motion.img
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                src={prodepLogo}
                style={{ width: "40%", height: "80%" }}
              />
            )}
          </div>
          <div style={{ width: "100%", height: "50%" }}>
            {isTabletOrMobile ? (
              <Typography
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                style={{
                  color: "black",
                  textAlign: "center",
                  fontFamily: "tenorite",
                  marginTop: "10px",
                  fontSize: "18px",
                }}
              >
                <motion.span>
                  SMART SOCIAL MEDIA <br /> PROCRASTINATION AND DEPRESSION
                  TRACKER{" "}
                </motion.span>
              </Typography>
            ) : (
              <Typography
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                style={{
                  color: "black",
                  textAlign: "center",
                  fontFamily: "tenorite",
                  marginTop: "10px",
                  fontSize: "20px",
                }}
              >
                <motion.span>
                  SMART SOCIAL MEDIA PROCRASTINATION <br /> AND DEPRESSION
                  TRACKER{" "}
                </motion.span>
              </Typography>
            )}
          </div>
          {isTabletOrMobile ? (
            ""
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <motion.img
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                src={prodepnames}
                style={{ width: "80%", height: "100%" }}
              />
            </div>
          )}

          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            style={{
              width: "100%",
              height: "60%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Button
              onClick={clickViewPaperBtnHandler}
              variant="outlined"
              style={{
                color: "black",
                borderColor: "black",
                marginRight: "40px",
              }}
            >
              View Paper
            </Button>
            <Button
              onClick={clickSourceCodeBtnHandler}
              variant="outlined"
              style={{ color: "black", borderColor: "black" }}
            >
              Source Code
            </Button>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Research;
